import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import AdminPageHead from 'appSrc/AdminPanel/pages/Common/PageHead';
import { LoadingOverlay } from 'appSrc/components/Shards';
import style from './styles/style.module.css';

class ProductsReports extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: false,
        };
    }
    createCSVDownload = (csvData, fileName) => {
        var a = document.createElement('a');
        let blob = new window.Blob([csvData], {type : 'text/csv'});
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }
    downloadLinkAudit = () => {
        this.setState( { fetching: true } );
        this.props.getLinkAuditCSV()
        .then( ( linkAuditCSV ) => {
            this.createCSVDownload(linkAuditCSV, 'desireco-link-audit.csv');
            this.setState( { fetching: false } );
        } );
    }
    downloadRecentProducts = () => {
        this.setState( { fetching: true } );
        this.props.getRecentProductsCSV()
        .then( ( recentProductsCSV ) => {
            var d = ( new Date() ).toISOString().replace( /T.*/, '' );
            this.createCSVDownload(recentProductsCSV, `desireco-recent-products_${ d }.csv`);
            this.setState( { fetching: false } );
        } );
    }
    downloadProductsWithoutReviews = () => {
        this.setState( { fetching: true } );
        this.props.getProductsWithoutReviewsCSV()
        .then( ( productsWithoutReviewsCSV ) => {
            var d = ( new Date() ).toISOString().replace( /T.*/, '' );
            this.createCSVDownload(productsWithoutReviewsCSV, `desireco-products-without-reviews_${ d }.csv`);
            this.setState( { fetching: false } );
        } );
    }
    downloadReviewAudit = () => {
        this.setState( { fetching: true } );
        dAPI.get( '/admin/content-metrics/review-audit?csv=true' )
        .then( ( csvData ) => {
            var d = ( new Date() ).toISOString().replace( /T.*/, '' );
            this.createCSVDownload(csvData, `desireco-review-audit_${ d }.csv`);
            this.setState( { fetching: false } );
        } );
    }
    downloadListsWithoutVideos = () => {
        this.setState( { fetching: true } );
        this.props.getListsWithoutVideosCSV()
        .then( ( listsWithoutVideosCSV ) => {
            var d = ( new Date() ).toISOString().replace( /T.*/, '' );
            this.createCSVDownload(listsWithoutVideosCSV, `desireco-lists-without-videos_${ d }.csv`);
            this.setState( { fetching: false } );
        } );
    }
    downloadTotalCountMetrics = () => {
        this.setState( { fetching: true } );
        this.props.getTotalCountMetricsCSV()
        .then( ( totalCountMetricsCSV ) => {
            var d = ( new Date() ).toISOString().replace( /T.*/, '' );
            this.createCSVDownload(totalCountMetricsCSV, `desireco-total-counts_${ d }.csv`);
            this.setState( { fetching: false } );
        } );
    }
    downloadVideosByCategory = () => {
        this.setState( { fetching: true } );
        this.props.getVideosByCategoryCSV()
        .then( ( videosByCategoryCSV ) => {
            var d = ( new Date() ).toISOString().replace( /T.*/, '' );
            this.createCSVDownload(videosByCategoryCSV, `desireco-videos-by-category_${ d }.csv`);
            this.setState( { fetching: false } );
        } );
    }
    render() {
        return (
            <section className={ style.page }>
                <AdminPageHead title='Reports' />
                <div className={ style.body }>
                    <section className={ style.reports }>
                        <ul>
                            <li><span onClick={ this.downloadLinkAudit }>Link Audit</span></li>
                            <li><span onClick={ this.downloadReviewAudit }>Review Audit</span></li>
                            <li><span onClick={ this.downloadRecentProducts }>Recent Products</span></li>
                            <li><span onClick={ this.downloadProductsWithoutReviews }>Get products that lack reviews</span></li>
                            <li><span onClick={ this.downloadListsWithoutVideos }>Get lists that lack videos</span></li>
                            <li><span onClick={ this.downloadTotalCountMetrics }>Get total count metrics</span></li>
                            <li><span onClick={ this.downloadVideosByCategory }>Get videos by category</span></li>
                        </ul>
                    </section>
                    { this.state.fetching &&
                        <LoadingOverlay />
                    }
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getLinkAuditCSV: () => {
            return dAPI.get( '/admin/linkAuditCSV' );
        },
        getRecentProductsCSV: () => {
            return dAPI.get( '/admin/recent-products/csv' );
        },
        getProductsWithoutReviewsCSV: () => {
            return dAPI.get( '/admin/content-metrics/products-without-reviews?csv=true' );
        },
        getListsWithoutVideosCSV: () => {
            return dAPI.get( '/admin/content-metrics/lists-without-videos?csv=true' );
        },
        getTotalCountMetricsCSV: () => {
            return dAPI.get( '/admin/content-metrics/total-counts?csv=true' );
        },
        getVideosByCategoryCSV: () => {
            return dAPI.get( '/admin/content-metrics/videos-by-category?csv=true' );
        },
    };
};

export default connect( null, mapDispatchToProps )( ProductsReports );
